import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import HomePage from "./Homepage";

export default function FormBuilder() {
 
  return (
    <DashboardLayout>
      <div className="w-full h-full px-4 py-8 bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800">
        <HomePage />
      </div>
    </DashboardLayout>
  );
}

